import Contact from 'Components/Contact/Contact';
import Footer from 'Components/Home/Footer';
import Navbar from 'Components/Home/Navbar';
import MainHeadingSub from 'Components/MainHeading/MainHeadingSub';
import React from 'react';
import contactUsImg from 'Assets/elvotaimages/Heading/contactUsImg.jpg';
import FooterTop from 'Components/FooterTop/FooterTop';

export default function ContactUs() {
  return (
    <div>
      <Navbar />
      <MainHeadingSub
        simple="Get in "
        highlighted="Touch"
        imageSrc={`linear-gradient(0deg, rgba(17, 64, 54, 0.2), rgba(17, 64, 54, 0.2)), url(${contactUsImg})`}
      />
      <div className="container-outer-spacing lg:pb-[250px] pb-[150px]">
        <Contact />
      </div>
      <FooterTop />
      <Footer />
    </div>
  );
}
